import React, { useEffect, useRef, useState } from "react";
import "./PapayaContact.scss"
import fb from "../assets/fb.svg"
import tt from "../assets/tt.svg"
import insta from "../assets/insta.svg"
import InputComponent from "../components/InputComponents/InputComponent";
import { contactEnquiry } from "../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import TextAreaComponent from "../components/InputComponents/TextAreaComponent";
import { useSelector } from "react-redux";
import MapLocationComponent from "../components/Footer/MapLocationComponent";
import { sortByOrderAscending } from "../helper/helper";
import CustomVideoPlayer from "../components/CustomVideoPlayer/CustomVideoPlayer";
const PapayaContact = () => {
    const company = useSelector((state) => state.companyData.company)
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "contactUs")

    const Components = page?.Components || []
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const [fullName, setFullName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [errors, setErrors] = useState({
        fullName: "",
        email: "",
        message: "",
        phoneNumber: "",
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        const container = containerRef.current;
        const content = contentRef.current;

        if (!container || !content) return;

        let scrollLeft = 0;
        let animationFrame;

        const clone = content.cloneNode(true);
        container.appendChild(clone);

        const animate = () => {
            scrollLeft += 0.5;
            if (scrollLeft >= content.scrollWidth) {
                scrollLeft = 0;
            }
            container.scrollLeft = scrollLeft;
            animationFrame = requestAnimationFrame(animate);
        };

        animationFrame = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrame);
    }, []);
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        const nameRegex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;
        let newErrors = {
            fullName: "",
            email: "",
            message: "",
            phoneNumber: "",
        }
        const trimmedName = fullName.trim();
        const trimmedEmail = email.trim();
        const trimmedPhone = phoneNumber.trim();
        if (trimmedName === "") {
            newErrors.fullName = "*Required";
            valid = false;
        } else if (trimmedName.length < 2 || !nameRegex.test(trimmedName)) {
            newErrors.fullName = "Please enter a valid name";
            valid = false;
        }


        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }


        if (trimmedPhone === "") {
            newErrors.phoneNumber = "*Required";
            valid = false;
        }

        if (message.trim() === "") {
            newErrors.message = "*Required";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": company?.ID || "",
            "Name": fullName,
            "Email": email,
            "PhoneNo": phoneNumber,
            "Message": message,
            "Subject": "",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setFullName("")
                setMessage("")
                setPhoneNumber("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };
    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "PapayaContactus-Hero-header":
                return <div className="PapayaContact-Hero-header">
                    {component?.Props?.text}
                </div>
            case "PapayaContactus-Hero-subheader":
                return <div className="PapayaContact-Hero-subheader">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="PapayaContact-Hero"
                style={{
                    backgroundImage: ` linear-gradient(rgba(14, 17, 13, 0.7), rgba(14, 17, 13, 0.7)), url(${heroBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHeroComponent(component)
                    )
                })}
            </div>
        )
    }
    const getForm = (props) => {
        return (<div className="PapayaContact-Form-Right">
            <InputComponent
                label={"Your Name"}
                placeholder={"e.g. John"}
                value={fullName}
                onChange={(e) => {
                    setFullName(e.target.value)
                    handleChange("fullName")
                }}
                error={errors.fullName !== ""}
                errorText={errors.fullName} />
            <div className="PapayaContact-Form-Right-flex">
                <InputComponent
                    label={"email address"}
                    placeholder={"e.g. John@example.com"}
                    onChange={(e) => {
                        setEmail(e.target.value)
                        handleChange("email")

                    }}
                    value={email}
                    error={errors.email !== ""}
                    errorText={errors.email} />
                <InputComponent
                    label={"phone number"}
                    placeholder={"e.g. +44 1234 5667890"}
                    onChange={(e) => {
                        setPhoneNumber(e.target.value)
                        handleChange("phoneNumber")

                    }}
                    value={phoneNumber}
                    error={errors.phoneNumber !== ""}
                    errorText={errors.phoneNumber}
                    type="number" />

            </div>
            <TextAreaComponent
                label={"message"}
                placeholder={"Write Message.."}
                onChange={(e) => {
                    setMessage(e.target.value)
                    handleChange("message")

                }}
                value={message}
                error={errors.message !== ""}
                errorText={errors.message} />
            {showSuccess && < div className="succes-alert">
                ✔ Thanks for contacting us! We’ve received your message and will be in touch soon.
            </div>}
            <div className="PapayaContact-Form-Right-button"
                onClick={() => {
                    handleContact()
                }}>
                {loading && <div className="PapayaContact-Form-Right-button-loader-btn" />}   {props?.btnText}
            </div>
        </div>)
    }
    const getFormContentComponent = (props) => {
        return (
            <div className="PapayaContact-Form-Left">
                <div className="PapayaContact-Form-Left-subheader">
                    <span />  {props?.subheader}
                </div>
                <div className="PapayaContact-Form-Left-header">
                    {props?.header} <span>{props?.headerHighlight}</span>
                </div>
                <div className="PapayaContact-Form-Left-content">
                    {props?.content}
                </div>
                <div className="PapayaContact-Form-Left-content2">{companyDetails?.address?.city}, {companyDetails?.address?.postcode}, {companyDetails?.address?.state}, {companyDetails?.address?.country}</div>
                <div className="PapayaContact-Form-Left-content2">{companyDetails?.contactNumber}</div>
                <div className="PapayaContact-Form-Left-content2">{companyDetails?.email}</div>
                <div className="PapayaContact-Form-Left-social">
                    {company?.SocialMedias
                        ?.facebook && company?.SocialMedias
                            ?.facebook !== "" && <div className="PapayaContact-Form-Left-social-item"><img alt="" src={fb}
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.facebook, '_blank')
                                }} /></div>}
                    {company?.SocialMedias
                        ?.instagram && company?.SocialMedias
                            ?.instagram !== "" && <div className="PapayaContact-Form-Left-social-item"><img alt=""
                                src={insta}
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.instagram, '_blank')
                                }} /></div>}
                    {company?.SocialMedias
                        ?.tiktok && company?.SocialMedias
                            ?.tiktok !== "" && <div className="PapayaContact-Form-Left-social-item"><img alt="" src={tt}
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.tiktok, '_blank')
                                }} /></div>}
                </div>
            </div>
        )
    }
    const getFormComponent = (component) => {
        switch (component.ID) {
            case "PapayaContactus-Form-content":
                return getFormContentComponent(component?.Props)
            case "PapayaContactus-Form-form":
                return getForm(component?.Props)
            default:
                return <div />
        }

    }
    const getFormContent = (components) => {
        return (
            <div className="PapayaContact-Form">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getFormComponent(component)
                    )
                })}
            </div>
        )
    }
    const getImagesCarousel = (data) => {
        return (
            <div className="PapayaContact-ImageCarousel" ref={containerRef}>
                <div className="PapayaContact-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        data?.src.includes(".mp4") ?
                            <CustomVideoPlayer
                                src={data?.src} key={index} /> : <img key={index} src={data?.src} alt={`img-${index}`} className="PapayaContact-Cont-image" />

                    ))}
                </div>
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "PapayaContactus-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "PapayaContactus-Form":
                return getFormContent(component.Components)
            case "PapayaContactus-Map":
                return companyDetails?.settings?.ShowAddressInMap && <MapLocationComponent lat={companyDetails?.address?.lat}
                    lng={companyDetails?.address?.lng}
                    borderRadius="0px"
                    height={window.screen.width < 900 ? "240px" : "600px"}
                />

            case "PapayaContactus-ImageCarousel":
                return getImagesCarousel(component.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="PapayaContact">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div>
    )
}
export default PapayaContact